import { ProductCollection } from "../components/product-collection/ProductCollection";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_ProductCollection";

const create = (data: any): JSX.Element => {
  return (
    <ProductCollection {...data.productFilter} showRefinements showPagination />
  );
};

export default { test, create };
